import { Feature, Point } from 'geojson';

import { SnBadgeConfig } from '@lib/ui/badge';

import { IBaseMarkerOptions } from './base-marker-options';
import {
  IGoogleMapNameIcon,
  IGoogleMapFontIcon,
  IGoogleMapFontIconUnicode,
} from './icon-marker-options';
import { GoogleMapMarkerType } from './marker-types';

export interface IGoogleMapMarkerStyleOptions {
  scale?: number;
  rotation?: number;
  fillColor?: string;
  fillOpacity?: number;
  strokeColor?: string;
  strokeWeight?: number;
  strokeOpacity?: number;
  url?: string;
  size?: google.maps.Size;
  scaledSize?: google.maps.Size;
}

export type GoogleMapMarkerStyleOptions = IGoogleMapMarkerStyleOptions;

export interface IGoogleMapMarkerLabel {
  text: string;
  color?: string;
  display?: string;
  className?: string;
}

export interface IGoogleMapMarkerIconOptions {
  color?: string;
  url?: string;
}

export interface IGoogleMapMarkerIconLabel {
  text: string;
  top?: number;
  left?: number;
  color?: string;
  fontSize?: string;
  transform?: string;
  field?: string;
}

export type GoogleMapMarkerIconLabel = IGoogleMapMarkerIconLabel;

export type GoogleMapMarkerIcon =
  | string
  | (IGoogleMapNameIcon & IGoogleMapMarkerIconOptions)
  | (IGoogleMapFontIcon & IGoogleMapMarkerIconOptions)
  | (IGoogleMapFontIconUnicode & IGoogleMapMarkerIconOptions);

export interface IGoogleMapMarkerOptions extends IBaseMarkerOptions {
  image?: any;
  icon?: GoogleMapMarkerIcon;
  iconLabel?: IGoogleMapMarkerIconLabel;
  type?: GoogleMapMarkerType;
  badge?: SnBadgeConfig;
  style?: IGoogleMapMarkerStyleOptions;
  label?: string | IGoogleMapMarkerLabel;
  draggable?: boolean;
  feature?: Feature<Point>;
}
